import { Resource } from 'idea-toolbox';
import { Role } from './permission.model';

export enum Languages {
  EN = 'en',
  ES = 'es',
  IT = 'it'
}
/**
 * Represent an ESN Section
 * Table: `jupiter_sections`.
 *
 * Indexes:
 *  - `sectionId-name-index` (GSI)
 */
export class Section extends Resource {
  public alias: string;
  public sectionId: string;
  public sectionInfo: SectionInfo;
  public languages: Array<Languages>;
  public contacts: SectionContacts;
  // TODO add options to select features
  public roles: Role[];

  public load(x: any) {
    super.load(x);
    this.alias = this.clean(x.alias, String);
    this.sectionId = this.clean(x.sectionId, String);
    this.sectionInfo = new SectionInfo(x.sectionInfo);
    this.languages = this.cleanArray(x.languages, () => Languages.EN); //Default language is English.
    this.contacts = new SectionContacts(x.contacts);
    this.roles = this.cleanArray(x.roles, (r: any) => r as Role);
  }

  public safeLoad(newData: any, safeData: any) {
    super.safeLoad(newData, safeData);
    this.alias = safeData.alias;
    this.sectionId = safeData.sectionId;
  }

  public validate(): string[] {
    super.validate();
    const e: string[] = [];
    e.push(...this.sectionInfo.validate());
    e.push(...this.contacts.validate());
    if (!this.languages.includes(Languages.EN)) {
      e.push(`default_language`);
    }
    return e;
  }
}

/**
 * A section's information.
 */
export class SectionInfo extends Resource {
  fullName: string;
  shortName: string;
  city: string;
  legalAddress: string;
  presidentEmail: string;
  presidentName: string;
  public load(x: any) {
    super.load(x);
    this.fullName = this.clean(x.fullName, String);
    this.shortName = this.clean(x.shortName, String);
    this.city = this.clean(x.city, String);
    this.legalAddress = this.clean(x.legalAddress, String);
    this.presidentEmail = this.clean(x.presidentEmail, String);
    this.presidentName = this.clean(x.presidentName, String);
  }
  public validate(): string[] {
    super.validate();
    const e: string[] = [];
    if (this.iE(this.fullName)) e.push(`fullName`);
    if (this.iE(this.shortName)) e.push(`shortName`);
    if (this.iE(this.city)) e.push(`city`);
    if (this.iE(this.legalAddress)) e.push(`legalAddress`);
    if (this.iE(this.presidentEmail)) e.push(`presidentEmail`);
    if (this.iE(this.presidentName)) e.push(`presidentName`);
    return e;
  }
}
/**
 * A section's contacts points.
 */
export class SectionContacts extends Resource {
  address: string;
  email: string;
  website: string;
  facebook: string;
  instagram: string;
  tiktok: string;
  x: string; //Formerly Twitter
  youtube: string;
  esncard: string;
  linkedin: string;
  public load(x: any) {
    super.load(x);
    this.address = this.clean(x.address, String);
    this.email = this.clean(x.email, String);
    this.website = this.clean(x.website, String);
    this.facebook = this.clean(x.facebook, String);
    this.instagram = this.clean(x.instagram, String);
    this.youtube = this.clean(x.youtube, String);
    this.esncard = this.clean(x.esncard, String);
    this.linkedin = this.clean(x.linkedin, String);
  }
}

// export class FinancialInfo extends Resource {
//   financialYear: string;
//   cashFlowNextSequence: number; //Starting from 1, it grows progressively until the financial year changes.
//   financialStartDay: number;
//   financialStartMonth: number;
//   pastYearRemainingBudget: number;
//   public load(x: any) {
//     super.load(x);
//     this.financialYear = this.clean(x.financialYear, String);
//     this.cashFlowNextSequence = this.clean(x.cashFlowNextSequence, Number);
//     this.financialStartDay = this.clean(x.financialStartDay, Number);
//     this.financialStartMonth = this.clean(x.financialStartMonth, Number);
//     this.pastYearRemainingBudget = this.clean(x.pastYearRemainingBudget, Number);
//   }
// }

/**
 * The possible email templates.
 */
export enum EmailTemplates {
  USER_REGISTRATION = 'USER_REGISTRATION',
  USER_REGISTRATION_ACCEPTED = 'USER_REGISTRATION_ACCEPTED',
  USER_REGISTRATION_REJECTED = 'USER_REGISTRATION_REJECTED',
  ROLE_CHANGED = 'ROLE_CHANGED',
  MEMBERSHIP_UPDATED = 'MEMBERSHIP_UPDATED',
  ESNCARD_UPDATED = 'ESNCARD_UPDATED',
  EVENT_REGISTRATION = 'EVENT_REGISTRATION',
  EVENT_REGISTRATION_ACCEPTED = 'EVENT_REGISTRATION_ACCEPTED',
  EVENT_REGISTRATION_REJECTED = 'EVENT_REGISTRATION_REJECTED',
  EVENT_REGISTRATION_CANCELLED = 'EVENT_REGISTRATION_CANCELLED',
  EVENT_TICKET_PURCHASED = 'EVENT_TICKET_PURCHASED',
}
